import React from 'react';

const ModalEmployee = params => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <path
      fill={params.color || '#108EE9'}
      fillRule="nonzero"
      d="M16 17.333c5.891 0 10.667 4.03 10.667 9v3H5.333v-3c0-4.97 4.776-9 10.667-9zm0-14.666c2.946 0 5.333 1.651 5.333 5.333 0 3.682-2.387 8-5.333 8s-5.333-4.318-5.333-8c0-3.682 2.387-5.333 5.333-5.333z"
    />
  </svg>
);

export default ModalEmployee;
